import styled, { keyframes } from 'styled-components';
import { fadeInUp } from 'react-animations';
const fadeInUpAnimation = keyframes`${fadeInUp}`;

export default styled.div`
  animation: ${props => props.duration || 300}ms ${fadeInUpAnimation};
  width: ${props => (props.widthPercentage ? props.widthPercentage : '100%')};
`;
